//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex'
import onClickOutside from '~/directives/click-outside'

export default {
  name: 'AppHeaderBag',

  directives: {
    clickOutside: onClickOutside
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    showLogin: false
  }),

  computed: {
    ...mapState('cart', ['items', 'totals']),
    ...mapGetters('cart', ['bagCount']),
    ...mapGetters('user', ['isGuest']),

    currentItems() {
      const items = Number(this.bagCount) !== 1 ? 'items' : 'item'

      return `${this.bagCount} ${items}`
    },

    buy3IncentiveMessage() {
      const remainder = 3 - this.bagCount

      if (remainder > 0) {
        const items = remainder !== 1 ? 'items' : 'item'
        return `Add ${remainder} more ${items} to <strong>save 15%!</strong>`
      }

      return `You've unlocked <strong>15% savings!</strong>`
    },

    freeShippingMessage() {
      const remainder = 50 - Number(this.totals.subtotal)

      if (remainder > 0) {
        return `Only $${remainder} away from <strong>FREE SHIPPING!</strong>`
      }

      return 'You qualify for FREE SHIPPING!'
    }
  },

  watch: {
    $route: 'dismiss'
  },

  methods: {
    dismiss() {
      this.$emit('close')
    },

    closeBag() {
      if (!this.showLogin) {
        this.dismiss()
      }
    },

    goToCheckout() {
      const path = this.isGuest ? '/get_started?from=cart' : '/recommendations'
      this.$router.push({ path })

      this.dismiss()
    }
  }
}
